<template>
<!-- 移动端导航栏 -->
  <div class="mobile-nav">
    <!-- 顶部栏 -->
    <div class="mobile-nav-header">
      <button class="menu-trigger" @click.stop="toggleMenu">
        <span class="hamburger-icon"></span>
      </button>
      <router-link to="/" class="logo" @click="closeMenu">
        <img src="@/assets/logo.png" alt="ctcsci" />
        <span class="logo-text">ctcsci</span>
      </router-link>
      <LanguageSelector />
    </div>

    <!-- 遮罩层 -->
    <div class="menu-overlay" v-if="isMenuOpen" @click="closeMenu"></div>

    <!-- 侧边菜单 -->
    <div class="mobile-menu" :class="{ 'menu-open': isMenuOpen }">
      <div class="menu-item">
        <div class="menu-title" @click="toggleSubmenu('product')">
          {{ t('nav.products') }}
          <img :src="expandedMenus.product ? topIcon : bottomIcon" 
               class="dropdown-icon" 
               alt="dropdown" />
        </div>
        <div class="submenu" v-show="expandedMenus.product">
          <router-link @click="closeMenu" to="/product/ip-transit">{{ t('nav.ipTransit') }}</router-link>
          <router-link @click="closeMenu" to="/product/cloud-vm">{{ t('nav.cloudVM') }}</router-link>
          <router-link @click="closeMenu" to="/product/bare-metal">{{ t('nav.bareMetal') }}</router-link>
          <router-link @click="closeMenu" to="/product/sdwan">{{ t('nav.sdwan') }}</router-link>
        </div>
      </div>

      <div class="menu-item">
        <div class="menu-title" @click="toggleSubmenu('network')">
          {{ t('nav.network') }}
          <img :src="expandedMenus.network ? topIcon : bottomIcon" 
               class="dropdown-icon" 
               alt="dropdown" />
        </div>
        <div class="submenu" v-show="expandedMenus.network">
          <router-link @click="closeMenu" to="/network/global-network">{{ t('nav.globalNetwork') }}</router-link>
          <router-link @click="closeMenu" to="/network/locations">{{ t('nav.locations') }}</router-link>
          <router-link @click="closeMenu" to="/network/latency">{{ t('nav.latency') }}</router-link>
          <router-link @click="closeMenu" to="/network/ddos-shield">{{ t('nav.ddosShield') }}</router-link>
        </div>
      </div>

      <div class="menu-item">
        <div class="menu-title" @click="toggleSubmenu('company')">
          {{ t('nav.company') }}
          <img :src="expandedMenus.company ? topIcon : bottomIcon" 
               class="dropdown-icon" 
               alt="dropdown" />
        </div>
        <div class="submenu" v-show="expandedMenus.company">
          <router-link @click="closeMenu" to="/company/about">{{ t('nav.about') }}</router-link>
          <router-link @click="closeMenu" to="/company/careers">{{ t('nav.careers') }}</router-link>
        </div>
      </div>

      <div class="menu-item">
        <router-link @click="closeMenu" to="/pricing" class="menu-title">{{ t('nav.pricing') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useTranslation } from '@/utils/i18n'
import LanguageSelector from './LanguageSelector.vue'
import bottomIcon from '@/assets/icon/bottom.png'
import topIcon from '@/assets/icon/top.png'

const router = useRouter()
const { t } = useTranslation()
const isMenuOpen = ref(false)
const expandedMenus = ref({
  product: false,
  network: false,
  company: false
})

// 添加路由监听
router.afterEach(() => {
  closeMenu()
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})

// 添加点击外部关闭菜单
const handleClickOutside = (event) => {
  const menu = document.querySelector('.mobile-menu')
  const trigger = document.querySelector('.menu-trigger')
  if (isMenuOpen.value && menu && !menu.contains(event.target) && !trigger.contains(event.target)) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const toggleSubmenu = (menu) => {
  expandedMenus.value[menu] = !expandedMenus.value[menu]
}

const closeMenu = () => {
  isMenuOpen.value = false
  Object.keys(expandedMenus.value).forEach(key => {
    expandedMenus.value[key] = false
  })
}
</script>

<style scoped>
.mobile-nav {
  position: relative;
}

.mobile-nav-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  border-bottom: 1px solid #eee;
  justify-content: space-between;
}

.menu-trigger {
  flex: 0 0 auto;
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
}

.hamburger-icon {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  position: relative;
}

.hamburger-icon::before,
.hamburger-icon::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 2px;
  background: #333;
  left: 0;
}

.hamburger-icon::before {
  top: -6px;
}

.hamburger-icon::after {
  bottom: -6px;
}

.mobile-menu {
  position: fixed;
  top: 60px;
  left: -100%;
  width: 80%;
  height: calc(100vh - 60px);
  background: white;
  transition: left 0.3s ease;
  overflow-y: auto;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
  z-index: 1000;
}

.mobile-menu.menu-open {
  left: 0;
}

.menu-item {
  border-bottom: 1px solid #eee;
}

.menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
  color: #333;
  text-decoration: none;
}

.submenu {
  background: #f5f5f5;
}

.submenu a {
  display: block;
  padding: 12px 25px;
  color: #333;
  text-decoration: none;
}

.submenu a:hover {
  color: #1890ff;
}

.submenu a.router-link-active {
  color: #1890ff;
}

.menu-item a.menu-title {
  color: #333;
  text-decoration: none;
}

.menu-item a.menu-title:hover,
.menu-item a.menu-title.router-link-active {
  color: #1890ff;
}

.menu-title:hover {
  color: #1890ff;
}

.dropdown-icon {
  width: 10px;
  height: 9.6px;
}

.logo {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
}

.logo img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.logo-text {
  color: #000000;
  font-size: 20px;
}

:deep(.language-selector) {
  flex: 0 0 auto;
}

/* 添加遮罩层样式 */
.menu-overlay {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
</style> 